<form class="edit-form" *ngIf="!isLoading" [formGroup]="editForm" (submit)="onSubmit()">

  <mat-form-field>
    <mat-label>{{ 'repository.addresses.edit.name.label' | translate }}</mat-label>
    <input type="text" matInput formControlName="name">
    <mat-error>{{ 'repository.addresses.edit.name.errorMessage' | translate }}</mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'repository.addresses.edit.code.label' | translate }}</mat-label>
    <input type="text" matInput formControlName="code" [maxlength]="codeMaxLength">
    <mat-error>{{ 'repository.addresses.edit.code.errorMessage' | translate }}</mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'repository.addresses.edit.street.label' | translate }}</mat-label>
    <input type="text" matInput formControlName="street">
    <mat-error>{{ 'repository.addresses.edit.street.errorMessage' | translate }}</mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'repository.addresses.edit.streetNumber.label' | translate }}</mat-label>
    <input type="text" matInput formControlName="streetNumber">
    <mat-error>{{ 'repository.addresses.edit.streetNumber.errorMessage' | translate }}</mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'repository.addresses.edit.locality.label' | translate }}</mat-label>
    <input type="text" matInput formControlName="locality">
    <mat-error>{{ 'repository.addresses.edit.locality.errorMessage' | translate }}</mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'repository.addresses.edit.postalCode.label' | translate }}</mat-label>
    <input type="text" matInput formControlName="postalCode">
    <mat-error>{{ 'repository.addresses.edit.postalCode.errorMessage' | translate }}</mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'repository.addresses.edit.phone.label' | translate }}</mat-label>
    <input type="text" matInput formControlName="phone">
    <mat-error>{{ 'repository.addresses.edit.phone.errorMessage' | translate }}</mat-error>
  </mat-form-field>

  <app-multi-select-list
    formControlName="sites"
    [allItems]="sites"
    label="repository.addresses.edit.site.label"
    errorMsg="repository.addresses.edit.site.errorMessage"
    [title]="'repository.addresses.edit.site.label' | translate"
    [required]="false"
    [minItems]="0"
  ></app-multi-select-list>

  <app-multi-select-list
    formControlName="addressGroups"
    [allItems]="addressGroups"
    label="repository.addresses.edit.addressGroups.label"
    [title]="'repository.addresses.edit.addressGroups.title' | translate"
    [required]="false"
    [minItems]="0"
  ></app-multi-select-list>

  <section class="tagCheckboxContainer">
    <div class="flexChips">
      <mat-form-field class="tag-field">
        <mat-chip-grid #chipList aria-label="Puce selection" formControlName="tags">
          <mat-chip-row *ngFor="let tag of tags.value" [selectable]="selectable" [removable]="removable"
            (removed)="removeTagOrService('tags', tag)">
            {{tag}}
            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
          </mat-chip-row>
          <input placeholder="Puce(s) NFC" [matChipInputFor]="chipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
            (matChipInputTokenEnd)="addTagOrService('tags', $event)">
        </mat-chip-grid>
      </mat-form-field>

      <mat-icon [matTooltip]="'repository.addresses.edit.tooltipChip' | translate" color="primary">info</mat-icon>
    </div>

    <div class="flexChips">
      <mat-form-field class="tag-field">
        <mat-chip-grid #chipListServices aria-label="Puce selection" formControlName="services">
          <mat-chip-row *ngFor="let service of services.value" [selectable]="selectable" [removable]="removable"
            (removed)="removeTagOrService('services', service)">
            {{service}}
            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
          </mat-chip-row>
          <input placeholder="Service(s)" [matChipInputFor]="chipListServices"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
            (matChipInputTokenEnd)="addTagOrService('services', $event)">
        </mat-chip-grid>
      </mat-form-field>

      <mat-icon [matTooltip]="'repository.addresses.edit.tooltipChip' | translate" color="primary">info</mat-icon>
    </div>

    <div class="checkboxContainer">
      <mat-checkbox formControlName="isSender">Lieu d'enlèvement</mat-checkbox>
      <mat-checkbox formControlName="isReceiver">Destinataire</mat-checkbox>
    </div>
  </section>

  <app-validate-and-cancel (submitEvent)="endForm($event)" [editForm]="editForm"
    [disabling]="editForm.invalid || (!editForm.value.isSender && !editForm.value.isReceiver)"></app-validate-and-cancel>

</form>
<mat-spinner *ngIf="isLoading" [diameter]="35" color="primary"></mat-spinner>